import FinanceLinksSection from './FinanceLinksSection';
import { ReportsLinksSection } from './ReportsLinksSection';

const FinanceAndReports = () => (
    <>
        <FinanceLinksSection />
        <ReportsLinksSection />
    </>
);

export default FinanceAndReports;
